import { Block, Spinner } from '@mote/ui'

export function ScreenSpinner() {
  return (
    <Block align='center' justify='center' spreadX spreadY>
      <Spinner radius={65} />
    </Block>
  )
}
